import { useState, useEffect } from 'react';
import { IconCopy } from '@tabler/icons-react';
import { fetchSubscribers } from '../lib/forms';
import { showToast } from '../components/ui/Toast';

function niceDate(iso) {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'America/Guyana' });
}

// Copies text; falls back to a hidden textarea where the clipboard API is blocked.
async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e2) {
      return false;
    }
  }
}

export default function AdminSubscribers() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchSubscribers().then(res => {
      if (cancelled) return;
      setSubs(res.subscribers);
      setLoadError(res.error);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  const active = subs.filter(s => !s.unsubscribed_at);

  async function copyAll() {
    if (active.length === 0) return;
    const ok = await copyText(active.map(s => s.email).join(', '));
    if (ok) showToast(active.length + ' email' + (active.length === 1 ? '' : 's') + ' copied');
    else showToast('Could not copy. Select the emails in the list and copy them by hand.', 'error');
  }

  if (loading) return <p className="adm-sub">Loading subscribers...</p>;

  return (
    <div>
      <h1 className="adm-title">Newsletter subscribers</h1>
      <p className="adm-sub">
        People who joined from the box at the bottom of the shop. {active.length} subscribed
        {subs.length > active.length ? ', ' + (subs.length - active.length) + ' unsubscribed' : ''}.
      </p>

      <div className="adm-card">
        <div className="adm-card-title">Subscribers</div>
        <button className="adm-btn" disabled={active.length === 0} onClick={copyAll} style={{ marginBottom: 12 }}>
          <IconCopy size={14} /> Copy all emails
        </button>
        {loadError && <p style={{ fontSize: 12, color: '#8B2020' }}>{loadError}</p>}
        {!loadError && subs.length === 0 && <p style={{ fontSize: 12, color: '#888' }}>No subscribers yet.</p>}
        {subs.map(s => (
          <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 10, padding: '7px 0', borderBottom: '1px solid rgba(74,46,26,0.06)', fontSize: 13 }}>
            <span style={{ wordBreak: 'break-all', color: s.unsubscribed_at ? '#aaa' : 'inherit', textDecoration: s.unsubscribed_at ? 'line-through' : 'none' }}>{s.email}</span>
            <span style={{ fontSize: 11, color: '#888', whiteSpace: 'nowrap' }}>
              {s.unsubscribed_at ? 'Unsubscribed ' + niceDate(s.unsubscribed_at) : 'Joined ' + niceDate(s.created_at)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
